export const ACTIONS = {
  INIT: 'init',
  SET_DATA: 'set-data',
  ADD_TEXT: 'text',
  ADD_IMG: 'img',
  ADD_TRANSLATE: 'translate',
  RESET: 'reset',
};

export const INIT_STATE = {
  name: '',
  isPrivate: false,
  texts: {},
  imgs: {},
  translates: {},
  isReadyToRender: false,
  hasChanged: false,
}

const formReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ACTIONS.INIT: {
      let newState = {
        ...state,
        ...action.payload,
        hasChanged: false,
      }
      return newState;
    }
    case ACTIONS.ADD_TEXT: {
      const newState = {...state};
      newState.hasChanged = true;
      newState.texts[action.payload.name] = action.payload.value;
      return newState;
    }
    case ACTIONS.ADD_IMG: {
      const newState = {...state};
      newState.hasChanged = true;
      newState.imgs[action.payload.name] = action.payload.value;
      return newState;
    }
    case ACTIONS.ADD_TRANSLATE: {
      const newState = {...state};
      newState.hasChanged = true;
      const translate = !!newState.translates[action.payload.name] ? newState.translates[action.payload.name] : {en:'', es:''};
      translate[action.payload.lang] = action.payload.value;
      newState.translates[action.payload.name] = translate;
      return newState;
    }
    case ACTIONS.RESET: {
      const newState = {...state};
      newState.hasChanged = false;
      return  newState;
    }
    default:
      throw new Error(`Action of type ${action.type} not valid`);
  }
};
export default formReducer;